import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { GuestData } from '../../types';

export type GuestAccessStore = {
  data: GuestData | null;
  setGuestData: (data: GuestData | null) => void;
};

export const useGuestAccessStore = create(
  persist<GuestAccessStore>(
    (set) => ({
      data: null,

      setGuestData: (data) => set(() => ({ data })),
    }),
    {
      name: 'guest-access',
      version: 1,
    }
  )
);
